import { DeviceStatus } from '../../dashboard/deviceStatus';
import { useDevicesState } from "../../../utilities/useDevicesState";
import Enum from '../../../utilities/enum';
import api from '../../api/api';

export default function AllOrganisationKiosks(props) {
    const { kiosks, getKiosks, kiosksLoading } = useDevicesState(props.organisationId, props.token);

    const deleteKiosk = (deviceId) => {
        api.deleteKioskDevice(() => getKiosks(), () => {}, props.organisationId, deviceId, props.token);
    }

    return (
        <div className="container-fluid">
            {                
                <DeviceStatus
                    orderedDevices={kiosks}
                    deviceType={Enum.DeviceType[1]}
                    viewAll
                    organisationId={props.organisationId}
                    handleRefreshClick={getKiosks}
                    isLoading={kiosksLoading}
                    handleDelete={id => deleteKiosk(id)}
                    dangerThreshold={props.settings.kioskStatusWarningThreshold !== null ? props.settings.kioskStatusWarningThreshold : 30}
                    warningThreshold={props.settings.kioskStatusDangerThreshold !== null ? props.settings.kioskStatusDangerThreshold : 90}
                />              
            }
        </div>
    )
}